import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../../../shared/src/lib/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredPermission = route.data['permission']; // Permission required by the route
    if (!this.authService.isAuthenticated()) {
      // Navigate to login page if user is not authenticated
      this.router.navigate(['authentication/login']);
      return false;
    }

    if (requiredPermission) {
      const sadminBypass = route.data['sadminBypass'] === true;
      const isSuperAdmin = this.authService.getUserRole() === 'super_admin';
      if (!(sadminBypass && isSuperAdmin) && !this.authService.hasPermission(requiredPermission)) {
        this.router.navigate(['authentication/access-denied']);
        return false;
      }
    }

    return true; // User is allowed to access the route
  }
}

/**
 * Modern Angular functional route guard wrapper for AuthGuard.
 */
export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => inject(AuthGuard).canActivate(route, state);

